export enum AutomationTypeEnum {
  INITIAL_CONTACT = 'initial_contact',
  KEYWORD = 'keyword'
}
